module.exports = __webpack_public_path__ + "static/media/5-7.7579b48e.mp3";